import React from "react";
import { convert2label } from "@lib/helpers/StringHelper";
import { LANGUAGE_CODE } from "@lib/constants/Language";

type LanguageLabelProps = {
  languageCode?: string | null;
  fallback?: string;
};

const LanguageLabel: React.FC<LanguageLabelProps> = ({
  languageCode,
  fallback = "",
}) => {
  if (!languageCode) {
    return <>{fallback}</>;
  }

  const languageKey = Object.keys(LANGUAGE_CODE).find(
    (key) => LANGUAGE_CODE[key as keyof typeof LANGUAGE_CODE] === languageCode,
  );

  return <>{convert2label(languageKey || "") || fallback}</>;
};

export default LanguageLabel;
